<!-- 求职管理 -->
<template>
  <div class="container">
    <!-- 简历处理 -->
    <div class="tab-box">
      <div :class="{'tab-item':true,'tab-color':show==0}" @click="tabItem(0)">
        应聘简历
        <div :class="{'tab-icon':show==0}"></div>
      </div>
      <div :class="{'tab-item':true,'tab-color':show==1}" @click="tabItem(1)">
        邀请简历
        <div :class="{'tab-icon':show==1}"></div>
      </div>
    </div>
    <!--处理数据-->
    <van-tabs v-model="activeName" swipeable @click="tabTap" v-if="show==0">
      <!-- 全部 -->
      <van-tab :title="item" :name="index" v-for="(item,index) in tabList" :key="index">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
          >
            <div class="status-all" v-for="(item, index) in list" :key="index">
              <img :src="item.avatar" class="head-img" />
              <div class="user-box">
                <div @click="navDetails(item.job_apply_id,item.status,item.interview_status)">
                  <div class="user-name">
                    <span>{{item.username}}</span>
                    <span>{{item.status==1?'申请面试':item.status==2?item.interview_status==1?'面试中':item.interview_status==2?'面试通过':item.interview_status==3?'面试不通过':'取消面试':item.status==3?'不合适':'面试取消'}}</span>
                  </div>
                  <div class="user-icon">
                    <span>{{item.soldier_type==1?'非退役军人':item.soldier_type==2?'退役士兵':item.soldier_type==3?'士官':'专业军官'}}</span>
                    <span>{{item.education}}</span>
                    <span>{{birthdayList[index]}}岁</span>
                    <p v-show="item.status==2">{{arrList[index][1]}}</p>
                  </div>
                  <div class="user-position">
                    <div class="box">
                      <span>{{item.job_name}}</span>
                      <span>{{item.salary_type==0?item.min_salary+'-'+item.max_salary:'面议'}}</span>
                    </div>
                    <p>{{arrList[index][0]}}</p>
                  </div>
                </div>

                <div class="user-btn" v-show="item.interview_status==1&&item.status==2">
                  <button @click="notFit(item.job_apply_id)">取消面试</button>
                  <button @click="answers(item.job_apply_id)">面试完成</button>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <div v-if="show==1">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
        >
          <div class="status-all" v-for="(item, index) in list" :key="index">
            <img :src="item.avatar" class="head-img" />
            <div class="user-box">
              <div @click="navDetails(item.resume_id,item.status,item.interview_status)">
                <div class="user-name">
                  <span>{{item.name}}</span>
                  <span></span>
                </div>
                <div class="user-icon">
                  <span>{{item.soldier_type==1?'非退役军人':item.soldier_type==2?'退役士兵':item.soldier_type==3?'士官':'专业军官'}}</span>
                  <span>{{item.education_name}}</span>
                  <span>{{birthdayList[index]}}岁</span>
                  <!-- <p v-show="item.status==2">{{arrList[index][1]}}</p> -->
                </div>
                <div class="user-position">
                  <div class="box">
                    <span>{{item.job_intent}}</span>
                    <span>{{item.job_wage}}</span>
                  </div>
                  <!-- <p>{{arrList[index][0]}}</p> -->
                </div>
              </div>

              <div class="user-btn" v-show="item.interview_status==1&&item.status==2">
                <button @click="notFit(item.job_apply_id)">取消面试</button>
                <button @click="answers(item.job_apply_id)">面试完成</button>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 答复弹窗层 -->
    <van-popup v-model="answerShow" round :close-on-click-overlay="false">
      <div class="answer-box">
        <p>面试答复</p>
        <!-- 单选 -->
        <van-radio-group v-model="radio">
          <van-radio name="1">
            <span :class="radio==1?'checked':''">面试通过</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
          <van-radio name="2">
            <span :class="radio==2?'checked':''">不合适</span>
            <template #icon="props">
              <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
            </template>
          </van-radio>
        </van-radio-group>
        <!-- 理由 -->
        <van-field
          v-model="address"
          rows="4"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="请输入理由"
          show-word-limit
          v-show="radio==2"
        />
        <!-- 按钮 -->
        <div class="answer-btn">
          <button @click="answerShow=false">取消</button>
          <button @click="answer">确定</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  applicationList,
  cancel,
  interviewCommit,
  remouseInvite,
  inviteList
} from "@/api/apiData";
import { Toast } from "vant";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      tabList: [
        "待处理",
        "简历不合适",
        "面试中",
        "面试不通过",
        "面试通过",
        "面试取消",
        "拒绝面试"

      ],
      activeName: "a", //标签切换
      answerShow: false, //面试答复弹窗层
      radio: "0", //是否通过
      activeIcon: require("@/assets/img/user/select.png"),
      inactiveIcon: require("@/assets/img/user/unselect.png"),
      address: "",
      page: 0,
      offset: 10,
      totalPages: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      arrList: [],
      birthdayList: [],
      id: "",
      show: 0,
      status: 1,
      interview_status: ""
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    answers(id) {
      const that = this;
      that.id = id;
      that.answerShow = true;
    },
    // 简历筛选切换
    tabItem(val) {
      const that = this;
      that.show = val;
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.list = [];
      if (val == 0) {
        that.getList("1");
      } else {
        that.remouseInviteList();
      }
    },
    // 简历邀请
    remouseInviteList() {
      const that = this;
      let { token, page, totalPages, list, offset } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        token: token
      };
      if (totalPages > page) {
        inviteList(obj).then(res => {
          if (res.code == 1) {
            if (res.data.length > 0) {
              that.list = list.concat(res.data.list);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              setTimeout(() => {
                that.loading = false;
              }, 1500);

              let birthdayList = [];
              let nowDate = new Date().getFullYear();
              res.data.list.forEach(item => {
                let arr = item.birthday.split("-");
                let i = nowDate - Number(arr[0]);
                birthdayList.push(i + 1);
              });
              that.birthdayList = birthdayList;
            } else {
              that.finished = true;
            }
          } else {
            Toast.fail(res.msg);
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    },
    //面试结果答复
    answer() {
      var that = this;
      let { radio, address, id } = that;
      if (radio == 2) {
        if (address.replace(/[, ]/g, "").length == 0) {
          Toast.fail({
            message: "请填写不合适的理由",
            forbidClick: true
          });
          return;
        }
      }
      let obj = {
        job_apply_id: id,
        status: radio == 2 ? "3" : "2",
        reason: radio == 2 ? address : ""
      };
      interviewCommit(obj).then(res => {
        //(res);
        if (res.code == 1) {
          that.answerShow = false;
          Toast.success({
            message: "答复成功",
            forbidClick: true
          });
          that.page = 0;
          that.totalPages = 1;
          that.loading = false;
          that.finished = false;
          that.list = [];
          that.radio = 0;
          that.getList(that.status);
        } else {
          that.answerShow = false;
          Toast(res.msg);
        }
      });
    },
    // 面试取消
    notFit(id) {
      const that = this;
      that.$dialog
        .confirm({
          title: "取消",
          message: "是否取消面试"
        })
        .then(() => {
          cancel({ job_apply_id: id }).then(res => {
            //(res);
            if (res.code == 1) {
              Toast.success({
                message: "面试取消成功",
                forbidClick: true
              });
              that.page = 0;
              that.totalPages = 1;
              that.loading = false;
              that.finished = false;
              that.list = [];
              that.getList(that.status);
              // setTimeout(() => {
              //   that.$router.back();
              // }, 2000);
            } else {
              Toast(res.msg);
            }
          });
          // on close
        })
        .catch(() => {});
    },
    // 路由跳转
    navDetails(id, status, interview_status) {
      var that = this;
      const { show } = that;

      if (show == 0) {
        that.$router.push({
          name: "Resume",
          query: {
            type: 0,
            id: id,
            status: status,
            interview_status: interview_status
          }
        });
      } else {
        that.$router.push({
          name: "resumeDetails",
          query: {
            id: id,
            type: 1
          }
        });
      }
    },
    // tab点击
    tabTap(e) {
      const that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.loading = false;
      that.finished = false;
      switch (e) {
        case 0: //待处理
          that.status = 1;
          that.interview_status = "";
          break;
        case 1: //简历不合适
          that.status = 3;
          that.interview_status = "";
          break;
        case 2: //面试中
          that.status = 2;
          that.interview_status = "";
          break;
        case 3: //面试不通过
          that.status = "";
          that.interview_status = 3;
          break;
        case 4: //面试通过
          that.status = "";
          that.interview_status = 2;
          break;
        case 5: //面试取消
          that.status = "4";
          that.interview_status = "";
          break;
        case 6: //用户拒绝面试
          that.status =  "2";
          that.interview_status = "4";
          break;
      }
      // //(that.status);
      // //(that.interview_status);

      that.getList(that.status, that.interview_status);
    },
    // 上拉加载
    onLoad() {
      this.getList(this.status, this.interview_status);
    },
    // 下拉加载
    onRefresh() {
      const that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.getList(that.status, that.interview_status);
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    },
    // 申请记录列表
    getList(index, val) {
      // //(`status--${index}`);
      // //(`interview_status--${val}`);
      var that = this;
      let { page, totalPages, offset, list } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        status: index,
        interview_status: val
      };
      if (totalPages > page) {
        applicationList(obj).then(res => {
          if (res.code == 1) {
            if (res.data.list.length > 0) {
              that.list = list.concat(res.data.list);
              that.totalPages = Math.ceil(Number(res.data.total) / offset);
              that.page = page + 1;
              setTimeout(() => {
                that.loading = false;
              }, 1500);
              let arrList = [];
              let birthdayList = [];
              res.data.list.forEach(item => {
                let arr = item.interview_time.split(" ");
                arrList.push(arr);
              });
              let nowDate = new Date().getFullYear();
              // //(nowDate);
              res.data.list.forEach(item => {
                let arr = item.birthday.split("-");
                // //(arr);
                let i = nowDate - Number(arr[0]);
                birthdayList.push(i + 1);
              });
              that.arrList = arrList;
              that.birthdayList = birthdayList;
            } else {
              that.finished = true;
            }
          } else {
            Toast.fail(res.msg);
          }
        });
      } else {
        that.loading = false;
        that.finished = true;
      }
    }
  },
  created() {
    if (this.$route.query.show) {
      this.show = this.$route.query.show;
      this.tabItem(1);
    } else {
      this.getList(1, "");
    }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.container {
  background: #e6e6e6;
  padding-top: 0.06rem;
}
/deep/.van-tabs {
  background: #f7f7f7;
  .van-tabs--line .van-tabs__wrap {
    height: 0.6rem;
  }
}
/deep/.van-nav-bar__placeholder {
  height: 0.8rem !important;
}
/deep/.van-tabs__nav--line {
  padding-bottom: 0;
  .van-tab {
    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.45rem;
    color: rgba(179, 179, 179, 1);
  }
  .van-tab--active {
    color: rgba(51, 51, 51, 1);
    font-weight: 600;
  }
  .van-tabs__line {
    bottom: 0;
    width: 5% !important;
    background: #ff4343;
  }
}
// 邀请简历
.tab-box {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0.15rem 0;
  .tab-item {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    font-weight: 550;
    color: #b3b3b3;
    .tab-icon {
      width: 0;
      height: 0;
      border: 0.1rem solid;
      border-color: #ff4343 transparent transparent transparent;
      margin-top: 0.1rem;
      margin-left: 0.2rem;
    }
  }
  .tab-color {
    color: #ff4343;
  }
}
// 全部
.status-all {
  display: flex;
  align-items: center;
  padding: 0.36rem 0.32rem;
  justify-content: space-between;
  background: #fff;
  .head-img {
    width: 1.18rem;
    height: 1.18rem;
    border-radius: 50%;
    align-self: flex-start;
  }
  .user-box {
    width: 80%;
    border-bottom: 0.01rem solid rgba(178, 178, 178, 0.5);
    padding: 0 0 0.3rem;
    .user-name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.3rem;
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      span:last-child {
        font-size: 0.26rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: #ff4343;
      }
    }
    .user-icon {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.33rem;
      color: rgba(128, 128, 128, 1);
      position: relative;
      span {
        padding: 0.02rem 0.04rem;
        border-radius: 0.04rem;
        background: rgba(247, 247, 247, 1);
        font-size: 0.2rem;
        font-weight: 400;
        line-height: 0.28rem;
        color: rgba(128, 128, 128, 1);
        margin: 0.08rem 0.12rem 0.08rem 0;
      }
      p {
        position: absolute;
        right: 0;
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: rgba(51, 51, 51, 1);
      }
    }
    .user-position {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      position: relative;
      .box {
        display: flex;
        width: 80%;
        span {
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.33rem;
          color: rgba(51, 51, 51, 1);
          display: block;
          max-width: 1.5rem;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; //溢出不换行
          margin-right: 0.2rem;
        }
        // span::after {
        //   content: "";
        //   display: block;
        //   height: 0.25rem;
        //   width: 0.02rem;
        //   background: rgba(178, 178, 178, 0.8);
        //   margin: 0 0.2rem;
        // }
        span:nth-child(2) {
          margin-right: 0;
        }
      }
      p {
        position: absolute;
        right: 0;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(128, 128, 128, 1);
      }
    }
    .user-btn {
      display: flex;
      justify-content: flex-end;
      margin-top: 0.24rem;
      button {
        padding: 0.16rem 0.34rem;
        background: rgba(247, 247, 247, 1);
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(102, 102, 102, 1);
        margin-right: 0.2rem;
        border-radius: 0.08rem;
      }
      button:last-child {
        background: rgba(255, 67, 67, 1);
        color: rgba(255, 255, 255, 1);
        margin-right: 0;
      }
    }
  }
  .bottom-none {
    border: 0;
  }
}
.margin-bottom {
  margin-bottom: 0.2rem;
  padding-bottom: 0;
}
// 单选按钮
/deep/.van-radio-group {
  display: flex;
  align-items: center;
  padding: 0.2rem 0.4rem;
  background: rgba(247, 247, 247, 1);
  border-radius: 0.08rem;
  margin: 0.4rem 0;

  .van-radio {
    flex: 1;
    display: flex;
    align-items: center;
    color: rgba(204, 204, 204, 1);
    .img-icon {
      width: 0.4rem;
      height: 0.4rem;
    }
    .van-radio__label {
      font-size: 0.3rem;
      line-height: 0.42rem;
      color: #cccccc;
    }
    .checked {
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }
}
/deep/.van-cell {
  background: rgba(247, 247, 247, 1);
  padding: 0;
  border-radius: 0.08rem;
  .van-field__word-limit {
    padding: 0.1rem;
  }
  .van-field__control {
    padding: 0.21rem 0.24rem;
    line-height: 1.2;
  }
}
/deep/.van-field__control::-webkit-input-placeholder {
  color: rgba(204, 204, 204, 1);
  font-size: 0.26rem;
  font-weight: 400;
  line-height: 0.4rem;
}
// 答复弹窗
.answer-box {
  width: 6rem;
  padding: 0.4rem;
  p {
    font-size: 0.4rem;
    font-weight: bold;
    line-height: 0.56rem;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
  .answer-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.4rem;
    button {
      padding: 0.2rem 0;
      width: 48%;
      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(102, 102, 102, 1);
      border-radius: 0.08rem;
    }
    button:last-child {
      background: rgba(255, 67, 67, 1);
      color: #fff;
    }
  }
}
</style>